var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGateWayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 9.752,
    viewBox: "0 0 14 9.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2293",
    "data-name": "Rectangle 2293",
    width: 14,
    height: 9.752,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10791",
    "data-name": "Group 10791",
    transform: "translate(-20.5 -479.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10790",
    "data-name": "Group 10790",
    transform: "translate(20.5 479.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10789",
    "data-name": "Group 10789",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M56.926,0A6.019,6.019,0,0,1,61.2,1.839a.345.345,0,0,1,.042.515c-.14.13-.331.1-.511-.079a5.262,5.262,0,0,0-7.7.124.329.329,0,0,1-.491.075c-.147-.127-.139-.332.023-.517.016-.018.034-.035.051-.052A6.078,6.078,0,0,1,56.926,0",
    transform: "translate(-49.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M83.361,39.328a.293.293,0,0,1-.165.278.323.323,0,0,1-.381-.064,4.136,4.136,0,0,0-1.074-.751,3.871,3.871,0,0,0-4.274.626c-.21.189-.386.207-.531.055s-.11-.339.093-.524A4.537,4.537,0,0,1,83.173,39a.433.433,0,0,1,.188.327",
    transform: "translate(-73.094 -35.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M109.681,77.765a.316.316,0,0,1-.173.274.3.3,0,0,1-.323-.021,1.051,1.051,0,0,1-.138-.136,1.614,1.614,0,0,0-2.416.005.389.389,0,0,1-.407.146.29.29,0,0,1-.2-.226.314.314,0,0,1,.078-.292,2.293,2.293,0,0,1,3.5.024.441.441,0,0,1,.079.226",
    transform: "translate(-100.837 -72.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M13.97,124.309a1.889,1.889,0,0,0-2.027-1.468H8.92c-2.316,0-4.633,0-6.949,0A1.9,1.9,0,0,0,.1,125.358a1.95,1.95,0,0,0,1.252,1.233H12.682a2.216,2.216,0,0,0,.367-.116,1.705,1.705,0,0,0,.951-1.3v-.83c-.01-.012-.025-.023-.03-.037m-1.839,1.745q-2.562,0-5.124,0c-1.667,0-3.335-.021-5,.009a1.33,1.33,0,0,1-1.4-1.3,1.305,1.305,0,0,1,1.392-1.338c1.09-.008,2.18,0,3.27,0q3.355,0,6.71,0a1.325,1.325,0,0,1,1.415.989,1.3,1.3,0,0,1-1.257,1.637",
    transform: "translate(0 -116.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M238.983,147.589a.406.406,0,0,1-.439.415.417.417,0,0,1-.416-.42.436.436,0,0,1,.434-.436.422.422,0,0,1,.421.441",
    transform: "translate(-226.497 -139.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M186.576,147.617a.433.433,0,0,1-.448.417.428.428,0,0,1-.419-.444.434.434,0,0,1,.434-.41.441.441,0,0,1,.434.437",
    transform: "translate(-176.636 -139.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M212.715,147.617a.434.434,0,0,1-.868,0,.434.434,0,1,1,.868,0",
    transform: "translate(-201.499 -139.991)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateWayIcon);
export default __webpack_public_path__ + "static/media/GateWayIcon.5ed7b4850a7ec7ad01a9137c133bbb89.svg";
export { ForwardRef as ReactComponent };